// Thin wrapper preserving the nuxt-lenis composable API so existing call
// sites (Header, TOC, Teachable layout, ClassroomView) keep working after
// the migration to the custom plugin in plugins/0.lenis.client.ts.
export function useLenis() {
   const { $lenis, $lenisScrollState } = useNuxtApp();
   return {
      lenis: $lenis,
      scrollState: $lenisScrollState,
   };
}
